import { Link } from '@tanstack/react-router';
import { brandOriginUrl } from '@/api';
import type { PaymentProvider } from '@/domain/payments';
import { paymentProviderLogoUrl } from '@/domain/payment-providers';
import { cn } from '@/lib/cn';

export interface SelectedProviderHeaderProps {
  provider: PaymentProvider;
  changeTo: '/profile/deposits' | '/profile/withdrawals';
  selectedLabel?: string;
  changeLabel?: string;
  className?: string;
}

export function SelectedProviderHeader({
  provider,
  changeTo,
  selectedLabel = 'Selected provider',
  changeLabel = 'Change provider',
  className,
}: SelectedProviderHeaderProps) {
  const logoSrc = paymentProviderLogoUrl(brandOriginUrl(), provider.Name, provider.Logo);

  return (
    <div
      className={cn(
        'flex items-center gap-3 rounded-xl border border-border-subtle bg-bg-surface px-4 py-3',
        className,
      )}
    >
      <span className="flex h-12 w-[7.5rem] shrink-0 items-center justify-center overflow-hidden rounded-md bg-bg-elevated p-2">
        <img
          src={logoSrc}
          alt=""
          className="h-full w-full object-contain"
          onError={(event) => {
            event.currentTarget.style.visibility = 'hidden';
          }}
        />
      </span>
      <div className="min-w-0 flex-1">
        <p className="truncate text-[14px] font-bold text-text-primary">
          {provider.Name || selectedLabel}
        </p>
        <Link
          to={changeTo}
          className="text-[13px] text-action-primary hover:underline"
        >
          {changeLabel}
        </Link>
      </div>
    </div>
  );
}
